import { render, staticRenderFns } from "./BoardView.vue?vue&type=template&id=445596e4&scoped=true"
import script from "./BoardView.vue?vue&type=script&lang=js"
export * from "./BoardView.vue?vue&type=script&lang=js"
import style0 from "./BoardView.vue?vue&type=style&index=0&id=445596e4&prod&lang=scss"
import style1 from "./BoardView.vue?vue&type=style&index=1&id=445596e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445596e4",
  null
  
)

export default component.exports